export enum TimeCardType {
  Attendance = "Attendance",
  Leave = "Leave"
}

